import HowBookingWorks from './HowBookingWorks';

export default HowBookingWorks;
